import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Button from "../../common/button/button";
import { useForm } from "react-hook-form";
import TextareaWithLabel from "../../common/input/textareaWithLabel";
import { useTranslation } from "react-i18next";
import { newModalStyle, submitButtonStyle } from "../../reusable/styles";

const RejectTaskModal = (props) => {
  const { handleSubmit, register, reset } = useForm();
  const { t } = useTranslation();

  const onSubmit = (data) => {
    props.onConfirm(data.reason);
    reset();
  };

  const onClose = () => {
    reset();
    props.onClose();
  };

  return (
    <Modal
      open={props.open}
      closeOnEsc
      onClose={onClose}
      center
      styles={newModalStyle({ width: "450px" })}
    >
      <form className="modalForm" onSubmit={handleSubmit(onSubmit)}>
        <div className="form">
          <TextareaWithLabel
            label={t("pzValidationRequestModal.rejectReason")}
            name="reason"
            registerName="reason"
            register={register}
            textAreaStyle={{ minHeight: "160px" }}
            required
          />
          <Button text={t("Buttons.save")} buttonStyle={submitButtonStyle} />
        </div>
      </form>
    </Modal>
  );
};

export default RejectTaskModal;
